import { type ReactNode, type FC } from 'react';
import BrandFilter from './BrandFilter/BrandFilter';
import CategoryFilter from './CategoryFilter/CategoryFilter';
import SaleFilter from './SaleFilter/SaleFilter';
import styles from '../FilterList.module.scss?module';
import clsx from 'clsx';

export const onlineshopApiBaseUrl = '/api/onlineshop';

type FiltersPropsT = {
  children?: ReactNode;
};

const Filters: FC<FiltersPropsT> = ({ children }) => {
  return (
    <div className={clsx('d-flex flex-column', styles.FiltersContainer)}>
      <BrandFilter />
      <CategoryFilter />
      <SaleFilter />

      {children}
    </div>
  );
};

export default Filters;
